
@if(showHeader()){
  <app-header class="headerfooter" ></app-header>
}

<main class="main">

  <app-nav-bar *ngIf="authService.isLoggedIn() && !isAssessmentApp()"></app-nav-bar>
  <router-outlet />
  
</main>

@if(showFooter())
{
  <app-footer class="headerfooter" ></app-footer>
}